import { makeStyles } from "@material-ui/core";

export const useAddOnItemDetailsStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "90vh",
    maxWidth: "95vw"
  },
  moreDetails: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    color: "#f7815c",
    fontSize: "12px",
    fontWeight: 600,
    padding: 0,
    textDecoration: "underline",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  img: {
    margin: "auto"
  },
  title: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    fontSize: 26,
    fontWeight: 300,
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  subTitle: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    fontSize: 12,
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  price: {
    fontFamily: "Axiforma, serif, sans-serf !important",
    fontSize: 20,
    fontWeight: 500,
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  showQuantity: {
    backgroundColor: "#f3f3f3",
    borderRadius: 20,
    width: 130,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  button: {
    "color": "#f7815c",
    "borderRadius": 20,
    "width": 40,
    "height": 31,
    "border": 0,
    "cursor": "pointer",
    "&:disabled": {
      color: "#d0d0d0"
    }
  },
  add: {
    "color": "#f7815c",
    "width": 102,
    "height": 38,
    "marginLeft": 20,
    "borderRadius": 20,
    "backgroundColor": "white",
    "border": "1px solid #f7815c",
    "&:disabled": {
      color: "#f7815c"
    }
  }
}));
